import { Label } from '@radix-ui/react-label'
import { useTranslation } from 'react-i18next'
import PlentyBody from '#app/components/typography/plenty-body'
import { Icon } from '#app/components/ui/icon'
import { RadioGroupItem } from '#app/components/ui/radio-group'

const RadioOption = ({
	id,
	name,
	address,
	stock,
	selected, // Add selected prop
}: {
	id: string
	name: string
	address: string
	stock: number | undefined
	selected: boolean // Add selected prop type
}) => {
	const { t } = useTranslation('product_details_page')

	return (
		<Label
			htmlFor={id}
			className={`group flex cursor-pointer flex-row items-start gap-x-4 border-b border-beige-90 px-2 py-2 transition-colors hover:bg-beige-50 md:px-8 md:py-6 ${
				selected ? 'bg-beige-50' : ''
			}`}
		>
			<RadioGroupItem
				value={id}
				id={id}
				className="peer mt-2 border-0 bg-white text-black-90 ring-2 ring-beige-50 aria-checked:ring-mint-green-80p"
			/>
			<div className="gap-y-2 flex flex-col">
				<PlentyBody size="md" className="font-bold">
					{name}
				</PlentyBody>
				<PlentyBody size="md">{address}</PlentyBody>
				<div className="flex ">
					<Icon name="half-line" size="lg" className="mr-2" />

					<PlentyBody size="md">
						{' '}
						{t('stock_in_store', { stock: stock })}{' '}
					</PlentyBody>
				</div>
			</div>
		</Label>
	)
}

export default RadioOption
